<template>
  <div class="relative h-full">
    <BAlert
      v-if="isBannerNotif && countTotalCard >= minCard"
      show
      variant="warning"
      class="p-2"
    >
      <div class="flex flex-row items-center justify-between gap-2">
        <div>
          <div class="flex items-center gap-3 mb-[10px]">
            <img
              src="https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg"
              alt="Komerce"
            >
            <h4 class="text-black font-semibold m-0">
              Gunakan Kompoints-mu!
            </h4>
          </div>
          <BCardText class="text-[#333333]">
            Aktifkan Kompointsmu sekarang untuk bisa digunakan sebagai biaya
            pembuatan kartu.
          </BCardText>
        </div>
        <BButton
          size="sm"
          variant="outline-warning"
          @click="$router.push('/payment-setting')"
        >
          Aktifkan Kompoints
        </BButton>
      </div>
    </BAlert>

    <BCard
      class="mt-[5px]"
      body-class="flex flex-column justify-between"
    >
      <ValidationObserver #default="{ invalid }">
        <BForm>
          <BRow>
            <BCol cols="12">
              <div class="flex">
                <BButton
                  variant="primary"
                  size="sm"
                  class="mr-1 rounded-lg p-0"
                  @click="$router.back()"
                >
                  <feather-icon
                    size="2x"
                    icon="ChevronLeftIcon"
                  />
                </BButton>
                <div class="text-black font-semibold m-0 text-2xl">
                  Buat Kartu Baru
                </div>
              </div>
              <BRow class="mt-2">
                <BCol cols="12">
                  <BFormGroup>
                    <template #label>
                      <div class="text-black flex items-center">
                        <span class="text-md font-semibold">Pilih Kartu</span>
                        <span class="text-primary">*</span>
                      </div>
                    </template>
                    <BFormRadioGroup v-model="selectedLevel">
                      <BRow>
                        <BCol
                          v-for="item in optionsLevel"
                          :key="item.value"
                          cols="12"
                          md="12"
                          lg="6"
                          class="mb-2"
                        >
                          <div
                            class="p-2 !rounded-xl h-full border"
                            :class="selectedLevel === item.value ? 'bg-[#FFECE9] border-primary' : 'bg-white border-[#E0E0E0]'"
                          >
                            <span
                              v-if="item.allowedShowBadge"
                              class="absolute left-1/2 -translate-x-1/2 top-[0px] text-white rounded-b-full px-2 mb-1 text-xs md:text-base whitespace-nowrap z-10"
                              :class="item.badgeBg"
                            >
                              {{ item.badge }}
                            </span>
                            <div class="flex flex-col justify-center gap-2">
                              <BFormRadio
                                :value="item.value"
                                class="m-0"
                                :disabled="item.disabled"
                              />
                              <div class="m-auto">
                                <img
                                  :src="item.image"
                                  width="350"
                                  :alt="`Kartu ${item.text}`"
                                >
                              </div>
                              <strong class="text-black text-center text-lg">{{ item.text }}</strong>
                              <li
                                v-for="(desc, idx) in item.description"
                                :key="idx"
                                class="text-[#333333] text-justify"
                                v-html="desc"
                              />
                            </div>
                            <!-- </BFormRadio> -->
                          </div>
                        </BCol>
                      </BRow>
                    </BFormRadioGroup>
                  </BFormGroup>
                </BCol>
              </BRow>
              <BRow>
                <BCol cols="12">
                  <BFormGroup>
                    <template #label>
                      <div class="text-black flex items-center">
                        <span class="text-md font-semibold">Nama Kartu</span>
                        <span class="text-primary">*</span>
                        <img
                          v-b-popover.hover.top="'Nama ini akan muncul sebagai nama kartu'"
                          src="https://storage.googleapis.com/komerce/assets/svg/info-circle.svg"
                          alt="Komerce"
                          width="20"
                          class="ml-[5px] cursor-pointer"
                        >
                      </div>
                    </template>
                    <ValidationProvider
                      #default="{ errors }"
                      name="Nama Kartu"
                      :rules="{required: true, min: 3, max:15}"
                    >
                      <BFormInput
                        v-model="name"
                        placeholder="ex. Pembayaran Ads"
                        :state="errors.length > 0 ? false : null"
                        @keydown="onInput($event)"
                        @paste="onPaste($event)"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </BFormGroup>
                  <BFormGroup>
                    <template #label>
                      <div class="text-black flex items-center">
                        <span class="text-md font-semibold">Label Kartu</span>
                        <img
                          v-b-popover.hover.top="'Tandai kartu ini sesuai dengan merchant yang akan kamu tautkan'"
                          src="https://storage.googleapis.com/komerce/assets/svg/info-circle.svg"
                          alt="Komerce"
                          width="20"
                          class="ml-[5px] cursor-pointer"
                        >
                      </div>
                    </template>
                    <ValidationProvider
                      #default="{ errors }"
                      name="Label Kartu"
                      :rules="{max:50}"
                    >
                      <BFormInput
                        v-model="label"
                        placeholder="ex. Facebook, Tokopedia, Shopee"
                        maxlength="50"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </BFormGroup>
                </BCol>
              </BRow>
              <BRow>
                <BCol
                  cols="12"
                  md="6"
                  sm="12"
                  xl="4"
                >
                  <BCard
                    body-class="bg-[#FFECE9] rounded-xl flex flex-column justify-between h-[131px]"
                  >
                    <div class="text-[#F95031] font-semibold text-xl">
                      Saldo Kompay saat ini
                    </div>
                    <BSpinner
                      v-if="loading.balance"
                      variant="primary"
                      medium
                    />
                    <div
                      v-else
                      class="text-[#F95031] font-semibold text-3xl"
                    >
                      <BSpinner
                        v-if="loading.balance"
                        variant="primary"
                        medium
                      />
                      <div
                        v-else
                        class="text-[#F95031] font-semibold text-3xl"
                      >
                        {{ IDR(balanceSummary) }}
                      </div>
                    </div></BCard>
                </BCol>
              </BRow>
              <BRow>
                <BCol cols="12">
                  <BFormGroup>
                    <template #label>
                      <div class="text-black flex items-center">
                        <span
                          class="text-md font-semibold"
                        >Top Up Saldo Awal Komcard</span>
                        <span class="text-primary">*</span>
                        <img
                          v-b-popover.hover.top="
                            'saldo kartu komcards diambil dari saldo kompay'
                          "
                          src="https://storage.googleapis.com/komerce/assets/svg/info-circle.svg"
                          alt="Komerce"
                          width="20"
                          class="ml-[5px] cursor-pointer"
                        >
                      </div>
                    </template>
                    <ValidationProvider
                      #default="{ errors }"
                      name="Top Up Saldo Komcard"
                      :rules="{
                        required: true,
                        minAmountCreate: 'add',
                        maxAmountAdd: amountMaxCreate,
                      }"
                    >
                      <BFormInput
                        v-model="balance"
                        placeholder="Min. Rp 20.000"
                        :state="errors.length > 0 ? false : null"
                        @keypress="isNumber($event)"
                        @input="formatCurrency"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </BFormGroup>
                </BCol>
              </BRow>
              <!-- <BRow>
                <BCol
                  cols="12"
                  md="12"
                  sm="12"
                >
                  <BButton
                    v-for="item in listTopUp"
                    :key="item.id"
                    :variant="activeTopup === item.id ? 'outline-primary' : 'outline-secondary'"
                    class="mr-1 mt-[5px]"
                    :disabled="formatCurrency(balance)"
                    @click="active(item)"
                  >
                    <span class="font-semibold">{{ IDR(item.balance) }}</span>
                  </BButton>
                </BCol>
              </BRow> -->
            </BCol>
          </BRow>
          <BRow class="mt-1">
            <BCol
              lg="4"
              offset-lg="6"
              class="text-[#828282]"
            >
              Top Up Saldo Awal
            </BCol>
            <BCol
              class="d-flex justify-start sm:justify-end text-black"
              lg="2"
            >
              {{ balance === '' ? IDR(0) : balance }}
            </BCol>
          </BRow>
          <BRow class="my-1">
            <BCol
              lg="4"
              offset-lg="6"
              class="text-[#828282]"
            >
              Biaya Pembuatan Kartu
            </BCol>
            <BCol
              class="d-flex justify-start sm:justify-end text-black"
              lg="2"
            >
              {{ IDR(cardFee) }}
            </BCol>
          </BRow>
          <BRow
            v-if="!isBannerNotif"
            class="my-1"
          >
            <BCol
              lg="4"
              offset-lg="6"
              class="text-[#828282]"
            >
              <div class="flex items-center gap-2">
                <img
                  src="https://storage.googleapis.com/komerce/assets/icons/Kompoints.svg"
                  alt="Komerce"
                  width="20"
                >
                <span>Gunakan Kompoints</span>
                <BFormCheckbox
                  v-model="usedKompoints"
                  switch
                />
              </div>
            </BCol>
            <BCol
              class="d-flex justify-start sm:justify-end text-black"
              lg="2"
            >
              <div class="flex items-center gap-2">
                <span
                  :class="usedKompoints ? 'text-orange-400' : 'text-gray-500'"
                >-{{
                  IDRWithoutLbl(kompoints.setting.komcard_card_fee)
                }}</span>
                <img
                  v-b-popover.hover.top="
                    'Maksimal Kompoints yang dapat digunakan adalah 25.000 dan digunakan untuk membayar biaya pembuatan kartu'
                  "
                  src="https://storage.googleapis.com/komerce/assets/svg/info-circle.svg"
                  class="cursor-pointer"
                  alt="Komerce"
                  width="20"
                >
              </div>
            </BCol>
          </BRow>
          <BRow>
            <BCol
              lg="6"
              offset-lg="6"
            >
              <hr class="mt-0">
            </BCol>
          </BRow>
          <BRow>
            <BCol
              lg="4"
              offset-lg="6"
              class="text-black text-xl"
            >
              Total yang harus dibayarkan
            </BCol>
            <BCol
              class="d-flex justify-start sm:justify-end text-primary text-xl"
              lg="2"
            >
              {{ totalPayment === '' ? IDR(0) : totalPayment }}
            </BCol>
          </BRow>
          <BRow
            v-if="possiblility.ideal_balance > 0"
            class="mt-1"
          >
            <BCol
              lg="4"
              offset-lg="6"
              class="text-[#828282] text-xl flex items-center"
            >
              <span>Saldo Ideal Kompay</span>
              <BPopover
                triggers="hover"
                target="posibilityTooltip"
                placement="topLeft"
              >
                <span>Potensi Pendapatan Order Dikirim <b>{{ IDR(possiblility.income_order_potential) }}</b> - Ongkir Retur Ketika Sampai <b>{{ IDR(possiblility.ongkir_retur_on_finished) }}</b> - Resiko Ongkir Menjadi Retur <b>{{ IDR(possiblility.ongkir_risk_become_retur) }}</b> =
                  Saldo Ideal <b class="text-danger">{{ IDR(possiblility.ideal_balance) }}</b></span>
              </BPopover>
              <img
                id="posibilityTooltip"
                src="https://storage.googleapis.com/komerce/assets/svg/info-circle.svg"
                alt="Komerce"
                class="ml-[10px] w-[20px] cursor-pointer"
              >
            </BCol>
            <BCol
              class="d-flex justify-start sm:justify-end text-xl"
              lg="2"
            >
              {{ IDR(possiblility.ideal_balance) }}
            </BCol>
          </BRow>
          <BRow class="my-1 justify-end">
            <BCol
              lg="4"
              offset-lg="8"
              class="text-black text-xl"
            />
            <BCol
              class="d-flex justify-start sm:justify-end text-primary text-xl"
              lg="4"
            >
              <BButton
                variant="outline-primary"
                class="mr-1"
                @click="$router.go(-1)"
              >
                Batal
              </BButton>
              <BButton
                :variant="invalid || disabled || loading.possible || isPossibilitySubmit
                  ? 'secondary'
                  : 'primary'
                "
                :disabled="invalid || disabled || loading.possible || isPossibilitySubmit"
                @click="onCreate()"
              >
                <BSpinner
                  v-if="loading.possible"
                  small
                />
                Buat Kartu
              </BButton>
            </BCol>
          </BRow>
        </BForm>
      </ValidationObserver>
    </BCard>

    <ModalPIN
      id="modal-verify-pin"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Verifikasi PIN"
      description="Mohon verifikasi identitas kamu dengan masukan PIN"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Kembali"
      @on-confirm-button="onSubmit"
      @on-cancel-button="onClose"
    />
    <ModalAccountSuspended
      v-if="isSuspended"
      ref="modalAccountSuspended"
    />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { getUserData } from '@/auth/utils'
import {
  required, numeric, min, max,
} from '@validations'
import { IDR, IDRWithoutLbl } from '@/libs/currency'
import { komshipAxiosIns, newAxiosIns } from '@/libs/axios'
import { isNumber } from '@/libs/helpers'
import isNaN from 'lodash/isNaN'
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import { ModalAccountSuspended } from './components'
import { listTopUp } from './config'
import Template from '../komship/opsional/wa-notif/template-notifikasi/template.vue'

extend('minAmountCreate', {
  validate: value => {
    const minAmountCreate = 20000
    const amount = parseFloat(value.replace(/[Rp.p]/g, ''))

    return amount >= minAmountCreate
  },
  message: () => {
    const minAmountCreate = 20000
    return `Minimal ${IDR(minAmountCreate)}`
  },
})

extend('maxAmountAdd', {
  validate: (value, args) => {
    const maxAmountAdd = args[0]
    const amount = parseFloat(value.replace(/[Rp.p]/g, ''))
    return amount <= maxAmountAdd
  },
  message: (field, args) => {
    const maxAmountAdd = args[0]
    return 'Maaf saldo anda tidak mencukupi'
  },
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ModalPIN,
    ModalAccountSuspended,
  },
  data() {
    return {
      IDR,
      IDRWithoutLbl,
      required,
      numeric,
      min,
      max,
      label: '',
      name: '',
      balance: '',
      listTopUp,
      activeTopup: null,
      user: this.$store.state.auth.userData,
      balanceSummary: 0,
      countTotalCard: this.$route.query.count,
      minCardMessage:
        'Kamu telah membuat 5 kartu komcards. Biaya pembuatan kartu berikutnya adalah Rp20.000/kartu dengan saldo awal minimal Rp. 20.000. Periksa saldo kompaymu sebelum melanjutkan proses selanjutnya!',
      minCard: 5,
      isNumber,
      isNaN,
      disabled: false,
      loading: {
        balance: false,
        possible: false,
        kompoints: false,
        quotaCard: false,
      },
      possiblility: {},
      possibleCreate: false,
      kompoints: {},
      usedKompoints: false,
      amountMaxCreate: 0,
      dataBalanceAnalitycs: {},
      quotaCard: {},
      selectedLevel: null,
      availableLevel: {
        platinum: false,
        gold: false,
      },
      cardFee: 0,
    }
  },
  computed: {
    isSuspended() {
      const userData = getUserData()
      return userData && parseInt(userData.status, 10) === 4
    },
    totalPayment() {
      const formatedBalance = Number(this.balance.replace(/\D/g, ''))
      const kompointsFee = this.usedKompoints
        ? this.kompoints.setting.komcard_card_fee
        : 0
      return IDR(formatedBalance + this.cardFee - kompointsFee)
    },
    payload() {
      return {
        label: this.label === '' ? null : this.label,
        name: this.name,
        balance: Number(this.balance.replace(/[^0-9]/g, '')),
        card_fee: this.cardFee,
        card_fee_kompoints: this.usedKompoints
          ? this.kompoints.setting.komcard_card_fee
          : 0,
      }
    },
    active() {
      return value => {
        const { id, balance } = value
        this.balance = IDR(balance)
        this.activeTopup = id
        this.disabled = false
        this.possibleCreate = false
      }
    },
    formatCurrency() {
      return value => {
        const newValue = Number(value.replace(/\D/g, ''))
        this.balance = isNaN(newValue) ? value : IDR(newValue)
        this.activeTopup = null

        if (this.user.is_komship === 1) {
          if (this.usedKompoints) {
            if (this.possiblility.ideal_balance >= 0) {
              // ada saldo ideal
              const amountMaxCreate = this.balanceSummary
                - (this.cardFee - this.kompoints.setting.komcard_card_fee)
                - this.possiblility.ideal_balance
              this.amountMaxCreate = amountMaxCreate
            }
            if (this.possiblility.ideal_balance <= 0) {
              // tidak ada saldo ideal
              const amountMaxCreate = this.balanceSummary
                - (this.cardFee - this.kompoints.setting.komcard_card_fee)
              this.amountMaxCreate = amountMaxCreate
            }
          }

          if (!this.usedKompoints) {
            if (this.possiblility.ideal_balance >= 0) {
              // ada saldo ideal
              const amountMaxCreate = this.balanceSummary
                - this.cardFee
                - this.possiblility.ideal_balance
              this.amountMaxCreate = amountMaxCreate
            }
            if (this.possiblility.ideal_balance <= 0) {
              // tidak ada saldo ideal
              const amountMaxCreate = this.balanceSummary - this.cardFee
              this.amountMaxCreate = amountMaxCreate
            }
          }
          return
        }

        if (this.usedKompoints) {
          const amountMaxCreate = this.balanceSummary
            - (this.cardFee - this.kompoints.setting.komcard_card_fee)
          this.amountMaxCreate = amountMaxCreate
        }
        if (!this.usedKompoints) {
          const amountMaxCreate = this.balanceSummary - this.cardFee
          this.amountMaxCreate = amountMaxCreate
        }
      }
    },
    isBannerNotif() {
      return !this.kompoints.is_active
    },
    platinumUnavailable() {
      return !(this.quotaCard.platinum?.available !== 0 && this.availableLevel.platinum)
    },
    goldUnavailable() {
      return !(this.quotaCard.gold?.available > 0 && this.availableLevel.gold)
    },
    isPossibilitySubmit() {
      return (this.possibleCreate && !this.usedKompoints) || (this.platinumUnavailable && this.goldUnavailable)
    },
    optionsLevel() {
      const options = [
        {
          value: 'platinum',
          text: 'Platinum Card',
          image: this.platinumUnavailable
            ? 'https://storage.googleapis.com/komerce/assets/illustration/platinum_disabled.svg'
            : 'https://storage.googleapis.com/komerce/assets/svg/platinum-no-tag.svg',
          disabled: this.platinumUnavailable,
          badge: this.platinumUnavailable
            ? 'Tidak Tersedia'
            : 'Spending besar, lebih hemat dengan cashback',
          allowedShowBadge: this.platinumUnavailable,
          badgeBg: this.platinumUnavailable ? 'bg-[#828282]' : 'bg-primary',
          description: [
            'Cashback untuk tiap transaksi > Rp.750.000 (<a href="https://bantuan.komerce.id/id/article/leveling-user-komerce-1ad7xbg/" target="_blank" class="text-[#00BFFF]">Lihat detail</a>)',
            'Tabungan cashback dipotong Rp.6.500, bila gagal bayar karena saldo kurang (<a href="https://bantuan.komerce.id/id/article/tips-untuk-mencegah-decline-transaction-insufficient-balancesaldo-tidak-cukup-2ytr3d/" target="_blank" class="text-[#00BFFF]">Lihat detail</a>)',
            'Fitur auto top-up, buat jagain saldo kartu tetap aman (<a href="https://www.youtube.com/watch?v=bgwdnlwkTew" target="_blank" class="text-[#00BFFF]">Tutorial</a>)',
            'Daily spending tak terbatas',
            'Kartu tanpa batas (Unlimited)',
          ],
        },
        {
          value: 'gold',
          text: 'Gold Card',
          image: this.goldUnavailable
            ? 'https://storage.googleapis.com/komerce/core/disable.svg'
            : 'https://storage.googleapis.com/komerce/core/gold.svg',
          disabled: this.goldUnavailable,
          // eslint-disable-next-line no-nested-ternary
          badge: this.quotaCard.gold?.available === 0
            ? 'Jumlah kartu telah mencapai 10 kartu'
            : this.goldUnavailable
              ? 'Tidak Tersedia'
              : '',
          allowedShowBadge: this.goldUnavailable,
          badgeBg: 'bg-[#828282]',
          description: [
            'Tidak ada cashback',
            'Tidak ada biaya saat saldo tidak cukup',
            'Tidak bisa auto top-up',
            'Daily spending limit max Rp2,5 juta',
            'Slot max 10 kartu',
          ],
        },
      ]

      return options
    },
  },
  watch: {
    usedKompoints() {
      return this.formatCurrency(this.balance)
    },
  },
  mounted() {
    this.checkEligibility()
    this.getBalance()
    this.checkQuotaCard()
    this.getAvailableLevel()
    if (Number(this.countTotalCard) >= this.minCard) {
      this.getKompoints()
    }
    if (this.user.is_komship === 1) {
      this.checkPossible()
    }
    if (this.isSuspended) {
      this.$nextTick(() => {
        if (this.$refs.modalAccountSuspended) {
          this.$refs.modalAccountSuspended.show()
        }
      })
    }
    this.getCardFees()
  },
  methods: {
    async checkEligibility() {
      try {
        const [profileRes, scoreRes, cardRes, controlRes, unlimitedRes] = await Promise.all([
          komshipAxiosIns.post('/v1/my-profile'),
          newAxiosIns.get('/komcards/api/v1/user/nmp/score'),
          newAxiosIns.get('/komcards/api/v1/card/list?levels=bronze,platinum,gold'),
          newAxiosIns.get('/komcards/api/v1/user/control-account'),
          newAxiosIns.get('/komcards/api/v1/card/check-unlimited-quota'),
        ])

        const profile = profileRes.data.data
        const { score } = scoreRes.data.data
        const { filtered_total, quota } = cardRes.data.meta
        const typeControl = controlRes?.data?.data?.type_control
        const parentData = controlRes?.data?.data?.parent_user
        const isUnlimitedCard = unlimitedRes?.data?.data?.status

        // check KYC
        let isCheckKyc = false
        if (filtered_total >= 0) {
          if ([0, 1, 3, 4].includes(profile.verification_ktp_status)) {
            isCheckKyc = true
          }
        }

        // check CanAddCard
        let isCanAddCard = false
        const length = filtered_total || 0

        let currentScore = score
        if (parentData && parentData.nmp_score !== undefined && parentData.nmp_score !== null) {
          currentScore = parentData.nmp_score
        }

        if (currentScore >= 61 && currentScore <= 70) {
          isCanAddCard = length < 5
        } else if (currentScore >= 41 && currentScore <= 60) {
          isCanAddCard = length < 1
        } else if (currentScore >= 71) {
          isCanAddCard = true
        }

        if (
          (typeControl !== 'manual' && (isCheckKyc || !isCanAddCard))
          || (typeControl === 'manual' && filtered_total >= quota)
          || (filtered_total === quota && !isUnlimitedCard)
        ) {
          this.$router.replace('/komcards')
        }
      } catch (err) {
        this.$router.replace('/komcards')
      }
    },
    onInput(event) {
      const isLetter = (event.key >= 'a' && event.key <= 'z') || (event.key >= 'A' && event.key <= 'Z')
      const numberOnly = event.key >= '0' && event.key <= '9'
      const isControlKey = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Enter', 'Escape', 'Space'].includes(event.key)

      if (!(isLetter || numberOnly || isControlKey || event.key === ' ')) {
        event.preventDefault()
      }
    },
    onPaste(event) {
      // Get pasted data
      const pastedText = (event.clipboardData || window.clipboardData).getData('text')
      // if pasted text is not a number or a letter
      if (!/^[a-zA-Z0-9\s]+$/.test(pastedText)) {
        event.preventDefault()
      }
    },
    async getBalance() {
      this.loading.balance = true
      const url = `/v1/dashboard/partner/balanceSummary?partner_id=${this.user.id}`
      await komshipAxiosIns.get(url).then(res => {
        const {
          data: { balance },
        } = res.data
        this.balanceSummary = balance
        this.loading.balance = false
      })
    },
    async checkPossible() {
      this.loading.possible = true
      const partnerIds = this.user.partner_detail.id
      const url = `/komship/api/v1/admin/partner-consumables/balance-analitycs/${partnerIds}`
      await newAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          const { ideal_balance } = data
          const topup = Number(this.balance.replace(/[^0-9]/g, ''))

          this.possibleCreate = ideal_balance < topup
          this.possiblility = data
          this.loading.possible = false
        })
        .catch(() => {
          this.loading.possible = false
          this.$toast_error({ message: 'Gagal memuat data check withdrawal' })
        })
    },
    async getKompoints() {
      this.loading.kompoints = true
      const url = '/auth/api/v1/user/kompoints'
      await newAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.kompoints = data
          this.loading.kompoints = false
        })
        .catch(() => {
          this.loading.kompoints = false
          this.$toast_error({ message: 'Gagal mendapatkan kompoints' })
        })
    },
    async checkQuotaCard() {
      this.loading.quotaCard = true
      const url = '/komcards/api/v1/card/quota'
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.loading.quotaCard = false
          this.quotaCard = data
        })
        .catch(() => {
          this.loading.quotaCard = false
        })
    },
    async getCardFees() {
      const url = '/komcards/api/v1/card/fee'
      await newAxiosIns.get(url)
        .then(res => {
          const { card_fee } = res.data.data
          this.cardFee = card_fee
        })
        .catch(() => {
          this.cardFee = 0
        })
    },
    onCreate() {
      this.$bvModal.show('modal-verify-pin')
    },
    onClose() {
      this.$bvModal.hide('modal-verify-pin')
    },
    async onSubmit(pin) {
      const activeLevels = Object.fromEntries(
        Object.entries(this.availableLevel).filter(([_, val]) => val === true),
      )

      if (Object.keys(activeLevels).length === 0) {
        this.alertError('Tidak ada level yang tersedia untuk disubmit')
        return
      }

      const url = '/komcards/api/v1/card/create'
      const payload = {
        ...this.payload,
        pin,
        level: this.selectedLevel || Object.keys(activeLevels)[0],
      }

      await newAxiosIns.post(url, payload)
        .then(() => {
          this.$router.push('/komcards')
          const message = 'Permintaan pembuatan kartu komcards telah diajukan. Harap tunggu selama 1x24 jam'
          this.$toast_success({ message })
        })
        .catch(err => {
          const { message, code } = err.response.data
          if (message === 'card holder id not found' || code === 500) {
            this.$toast_error({ message: 'Terjadi kesalahan ketika membuat kartu, mohon hubungi team cs kami untuk lebih lanjut' })
            return
          }
          if (message === 'kompoints balance under minimal nominal') {
            this.$toast_error({ message: 'Maaf, jumlah Kompoints yang kamu pakai kurang dari minimal nominal penggunaan. Silahkan cek kembali pengaturan pembayaran yang kamu atur' })
          }
        })
    },
    async getAvailableLevel() {
      const url = '/komcards/api/v1/setting/available-level'
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data

          this.availableLevel = data
          const activeLevels = Object.fromEntries(
            Object.entries(this.availableLevel).filter(([_, val]) => val === true),
          )

          // jika available !(this.quotaCard.platinum?.available > 0 && this.availableLevel.platinum) maka pilih gold
          // !(this.quotaCard.platinum?.available > 0 && this.availableLevel.platinum),

          // this.selectedLevel = Object.keys(activeLevels)[0] || null
        })
        .catch(() => {
          this.alertError('Gagal load data kartu tersedia')
        })
    },
  },
}
</script>
<style scoped>
.alert-warning {
  background: #f8ecc8 !important;
}
</style>
